import { Link, Navigate, useParams } from "react-router-dom";
import Breadcrumbs from "./Breadcrumbs";
import { getBlogPostBySlug } from "../data/blogPosts";
import { useLanguage } from "../context/LanguageContext";

export default function BlogPostPage() {
  const { t } = useLanguage();
  const { slug } = useParams<{ slug: string }>();
  const post = slug ? getBlogPostBySlug(slug) : undefined;

  if (!post) return <Navigate to="/blog" replace />;

  const publishedLabel = new Date(post.publishedAt).toLocaleDateString("ru-RU", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });

  return (
    <article className="bg-white pb-24 pt-24 md:pb-32 md:pt-32">
      <Breadcrumbs items={[{ label: t("blogPageTitle"), href: "/blog" }, { label: post.title }]} />
      <div className="container-industrial max-w-3xl pt-16">
        <p className="text-xs font-semibold uppercase tracking-wide2 text-accent">{post.category}</p>
        <h1 className="mt-2 font-display uppercase text-3xl font-semibold tracking-[0.3px] leading-tight text-ink md:text-[2.5rem]">
          {post.title}
        </h1>
        <p className="mt-3 text-xs uppercase tracking-wide2 text-steel-500">{publishedLabel}</p>

        <div className="mt-8 aspect-[16/9] overflow-hidden bg-steel-100">
          <img src={post.image} alt={post.title} className="h-full w-full object-cover" />
        </div>

        <div className="mt-10 flex flex-col gap-8">
          {post.sections.map((section, i) => (
            <div key={section.heading ?? i}>
              {section.heading && (
                <h2 className="font-sans text-xl font-semibold tracking-tight text-ink">{section.heading}</h2>
              )}
              {section.paragraphs.map((paragraph, j) => (
                <p
                  key={paragraph}
                  className={`text-sm leading-relaxed text-steel-600 ${
                    section.heading || j > 0 ? "mt-3" : ""
                  }`}
                >
                  {paragraph}
                </p>
              ))}
            </div>
          ))}
        </div>

        <Link to="/contacts" className="btn-primary mt-12">
          {t("ctaButton")}
        </Link>
      </div>
    </article>
  );
}
